import { render, staticRenderFns } from "./searchrecords.vue?vue&type=template&id=79f58422"
import script from "./searchrecords.vue?vue&type=script&lang=js"
export * from "./searchrecords.vue?vue&type=script&lang=js"
import style0 from "./searchrecords.vue?vue&type=style&index=0&id=79f58422&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports